export default "__VITE_ASSET__CxjPQ6K$__"